/** Area-shaped input used when picking the expanded-area travel fee. */
export type ExpandedFeeArea = {
  serviceArea?: {
    expanded?: boolean;
    expandedFee?: number | null;
  } | null;
} | null;

/**
 * Travel fee for the primary service: highest `expandedFee` among containing
 * areas marked expanded. Unexpanded areas (including leftover stored fees)
 * contribute nothing — a property in only covered/unexpanded polygons is $0.
 */
export function pickExpandedAreaFee(
  areas: ExpandedFeeArea[] | null | undefined,
): number {
  if (!areas?.length) return 0;
  const fees = areas
    .filter((a) => a?.serviceArea?.expanded)
    .map((a) => Number(a?.serviceArea?.expandedFee) || 0);
  return fees.length ? Math.max(...fees) : 0;
}
